<template>
  <div class="setComponent">
    <!-- 表单 -->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="form-setting" size="medium">
      <!-- 自动转发 -->
      <div class="title">
        <h4>{{$t("wm_lang_html_35c8ad")}}</h4>
        <el-divider></el-divider>
      </div>
      <el-form-item label="" prop="radio" class="mb10">
        <el-radio-group :disabled="deliverForwardDisable" v-model="ruleForm.autoForward.forwardEnable">
          <el-radio :label="false">{{$t("wm_lang_html_b15d91")}}</el-radio>
          <el-radio :label="true">{{$t("wm_lang_html_7854b5")}}</el-radio>
        </el-radio-group>
        <a @click="logForward" class="float-r" style="text-decoration:underline;">{{$t("wm_lang_html_ecf9b6")}}</a>
        <span v-show="deliverForwardDisable" class="c_red">({{$t("wm_lang_html_ae2e1f")}})</span>
        <span v-show="deliverForwardForeign" class="c_red">({{$t("wm_lang_html_0b543c")}})</span>
      </el-form-item>
      <el-form-item>
        <el-input v-model="forwardEmail" :disabled="!ruleForm.autoForward.forwardEnable" class="w360"></el-input>
        <el-button @click.prevent="addAddress" type="primary">{{$t("wm_lang_html_b58c75")}}</el-button> <span class="c_red">{{$t("wm_lang_html_1a63ac")}}:name@example.com</span>
      </el-form-item>
      <el-form-item label="" class="mb0">
        <ul class="forward-list float-l">
          <li v-if="item" :class="sltedForwardAddrIndex === index ? 'selected' : ''" v-for="(item, index) in forwardList" @click="selectForwardAddr(index)">{{item}}</li>
        </ul>
        <input type="hidden" v-model="ruleForm.autoForward.forwardAddr">
        <el-button @click.prevent="deleteAddress" type="primary">{{$t("wm_lang_html_2f4aad")}}</el-button>
      </el-form-item>
      <el-form-item label="" prop="type">
        <el-checkbox-group v-model="ruleForm.autoForward.forwardDiscardEnable">
          <el-checkbox :label="$i18n.t('wm_lang_de0f82')"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <!-- 自动回复 -->
      <div class="title">
        <h4>{{$t("wm_lang_html_922a77")}}</h4>
        <el-divider></el-divider>
      </div>
      <!-- 提示栏 -->
      <el-alert  style="margin:15px 0;" :title="$i18n.t('wm_lang_c9ef57')" :closable="false" type="info"></el-alert>
      <el-form-item label="" prop="radio" class="mb0">
        <el-radio-group v-model="ruleForm.autoReply.replyEnable">
          <el-radio :label="false">{{$t("wm_lang_html_b15d91")}}</el-radio>
          <el-radio :label="true">{{$t("wm_lang_html_7854b5")}}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="" class="mb0">
        <el-checkbox-group v-model="ruleForm.autoReply.replyTimeEnable">
          <el-checkbox :label="$i18n.t('wm_lang_fd2bf0')" :disabled="!ruleForm.autoReply.replyEnable"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <!--<el-form-item label="">-->
        <!--<el-col :span="11">-->
          <!--<el-form-item prop="date1">-->
            <!--<el-date-picker type="date" placeholder=this.$i18n.t('wm_lang_2bebdd') :disabled="!ruleForm.replyEnable" v-model="ruleForm.replyStartTime" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>-->
          <!--</el-form-item>-->
        <!--</el-col>-->
        <!--<el-col class="line tc" :span="2">&#45;&#45;</el-col>-->
        <!--<el-col :span="11">-->
          <!--<el-form-item prop="date2">-->
            <!--<el-date-picker type="date" placeholder=this.$i18n.t('wm_lang_2bebdd') :disabled="!ruleForm.replyEnable" v-model="ruleForm.replyEndTime" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>-->
          <!--</el-form-item>-->
        <!--</el-col>-->
      <!--</el-form-item>-->
      <el-form-item class="mb10">
        <el-date-picker
          :disabled="!ruleForm.autoReply.replyEnable"
          v-model="replyTimeSpan"
          type="datetimerange"
          align="right"
          value-format="timestamp"
          :start-placeholder="$i18n.t('wm_lang_b44c0f')"
          :end-placeholder="$i18n.t('wm_lang_1d468b')"
          :default-time="['12:00:00', '12:00:00']">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="" class="mb0">
        <el-checkbox-group v-model="ruleForm.autoReply.replyContactEnable">
          <el-checkbox :label="$i18n.t('wm_lang_2ad202')" :disabled="!ruleForm.autoReply.replyEnable"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="">
        <el-checkbox-group v-model="ruleForm.autoReply.replyOnceEnable">
          <el-checkbox :label="$i18n.t('wm_lang_d27299')" :disabled="!ruleForm.autoReply.replyEnable"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="">
        <tinymce-editor ref="editor" :editorType="'base64'" v-model="ruleForm.autoReply.replyContent" :disabled="!ruleForm.autoReply.replyEnable" style="width:70%;"></tinymce-editor>
        <p class="f12 c_blue">{{$t("wm_lang_html_7d0177")}}Auto-Re:{{$t("wm_lang_html_b50566")}}Auto-Reply{{$t("wm_lang_html_b50566")}}Autoreply{{$t("custom_lang_0085")}}
        </p>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="saveForm('ruleForm')">{{$t("wm_lang_html_be5fbb")}}</el-button>
      </el-form-item>
    </el-form>

    <br><br>
  </div>
</template>

<script>
import xmail from '@/api/api';
import storeLocal from 'store';
import TinymceEditor from '@/components/views/editor/tinymce-editor'
import DialogHandle from "../../../utils/dialogHandle";
import { isEmail } from '@/utils/validate';
import { bitIs1 } from '@/utils/utils';

export default {
  name: 'forwardReply',
  data () {
    return {
      localConfigSetting: {},
      deliverForwardDisable: false,
      deliverForwardForeign: false,
      forwardAddrMax: 100,
      replyTimeSpan: [],
      forwardEmail: '',
      forwardList: [],
      sltedForwardAddrIndex: '',
      // 表单
      ruleForm: {
        "autoForward": {
          // "forwardAddr": "",
          "forwardAddr": [],
          "forwardDiscardEnable": true,
          "forwardEnable": true
        },
        "autoReply": {
          "replyEnable": true,
          "replyContent": "",
          "replyTimeEnable": true,
          "replyStartTime": "",
          "replyEndTime": "",
          "replyContactEnable": true,
          "replyOnceEnable": true
        }
      },
      rules: {}
    }
  },
  components:{
    DialogHandle,
    TinymceEditor
  },
  // computed: {
  //   sltedForwardAddrIndex() {
  //
  //   }
  // },
  mounted() {
    this.localConfigSetting = storeLocal.get('Pwm-configSetting');
    this.deliverForwardDisable = this.localConfigSetting.deliverSetting.forwardType === xmail.enums.RoleDeliverForwardType.DISABLE;
    this.deliverForwardForeign = this.localConfigSetting.deliverSetting.forwardType === xmail.enums.RoleDeliverForwardType.DISABLE_FOREIGN;
    this.forwardAddrMax = this.localConfigSetting.globalConfig.maximumLimit.forwardAddrMax;
    let self = this;
    (function (api, enums, pms) {
      api.Deliver.queryMailDeliver({}, function (res) {
        console.log(res.data)
        if(res.data.code === 0) {
          if(Object.keys(res.data.data).length === 0) {
            return;
          }
          self.ruleForm = res.data.data;
          self.ruleForm.autoForward.forwardDiscardEnable = !self.ruleForm.autoForward.forwardDiscardEnable;
          // console.log(self.ruleForm)
          // self.forwardList = self.ruleForm.autoForward.forwardAddr ? self.ruleForm.autoForward.forwardAddr.split(',') : [];
          self.forwardList = self.ruleForm.autoForward.forwardAddr ? self.ruleForm.autoForward.forwardAddr : [];
          self.replyTimeSpan = [self.ruleForm.autoReply.replyStartTime, self.ruleForm.autoReply.replyEndTime];
        }
      })
    })(xmail.api, xmail.enums, xmail.pms);
  },
  methods: {
    logForward() {
      this.$router.push({name: 'forwardReplyLog'});
    },
    selectForwardAddr(index) {
      this.sltedForwardAddrIndex = index;
    },
    addAddress() {
      let userInfo = storeLocal.get('Pwm-userInfo');
      let self = this;
      console.log(self.forwardList.length)
      if(self.forwardList.length >= this.forwardAddrMax) {
        this.$message({
          type: 'info',
          message: `${this.$i18n.t('custom_lang_0083')}${this.forwardAddrMax}${this.$i18n.t('wm_lang_930882')}！`
        })
        return;
      }

      if (self.forwardList.indexOf(self.forwardEmail) > -1) {
        this.$message({
          type: 'info',
          message: this.$i18n.t('wm_lang_fe30da')
        })
        return;
      }

      if(this.forwardEmail !== '') {
        if(isEmail(this.forwardEmail) === false){
          this.$message({
            type: 'info',
            message: this.$i18n.t('wm_lang_7b6234')
          })
        }
        else {
          (function (api, enums, pms) {
            let fpm = pms.Deliver.checkEmailParamBuilder();
            fpm.forwardAddr = self.forwardEmail;
            api.Deliver.checkEmail(fpm, (res) => {
              if (res.data.data.isOwnEmail) {
                self.$message({
                  type: 'info',
                  message: self.$i18n.t('wm_lang_198d41')
                })
                return;
              }
              if(res.data.data.isDisableForeign) {
                self.$message({
                  type: 'info',
                  message: self.$i18n.t('wm_lang_18b2e0')
                })
                return;
              }
              if (res.data) {
                self.forwardList.push(self.forwardEmail);
                self.forwardEmail = ''
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
        }
      }
      // this.ruleForm.forwardAddr = this.forwardList.toString()
    },
    deleteAddress() {
      if(this.sltedForwardAddrIndex === ''){
        return;
      }
      this.forwardList.splice(this.sltedForwardAddrIndex, 1);
      // this.ruleForm.forwardAddr = this.forwardList.toString()
    },
    saveForm(formName) {
      if(this.ruleForm.autoForward.forwardEnable && this.forwardList.length == 0) {
        this.$message({
            type: 'warning',
            message: this.$i18n.t('wm_lang_641b90')
          });
          return;
      }
      if(this.ruleForm.autoReply.replyEnable && this.ruleForm.autoReply.replyContent == '') {
        this.$message({
            type: 'warning',
            message: this.$i18n.t('wm_lang_fd2515')
          });
          return;
      }
      if(this.ruleForm.autoReply.replyEnable && this.ruleForm.autoReply.replyTimeEnable && this.replyTimeSpan === null) {
        this.$message({
          type: 'warning',
          message: this.$i18n.t('custom_lang_0086')
        });
        return;
      }
      // this.ruleForm.autoForward.forwardDiscardEnable = !this.ruleForm.autoForward.forwardDiscardEnable;
      this.$refs[formName].validate((valid) => {
        // console.log(valid);
        if (valid) {
          let self = this;
          (function (api, enums, pms) {
            // self.ruleForm.autoForward.forwardAddr = self.forwardList.join('§');
            self.ruleForm.autoForward.forwardAddr = self.forwardList;
            if(self.replyTimeSpan !== null) {
              self.ruleForm.autoReply.replyStartTime = self.replyTimeSpan[0];
              self.ruleForm.autoReply.replyEndTime = self.replyTimeSpan[1];
            }
            self.ruleForm.languageType = enums.LanguageType.cn; //语言类型后端不存，前端回显加入
            let pm = self.ruleForm;
            const autoForward = {
              "forwardAddr": pm.autoForward.forwardAddr,
              "forwardDiscardEnable": !pm.autoForward.forwardDiscardEnable,
              "forwardEnable": pm.autoForward.forwardEnable
            }
            // console.log(pm);
            // return;
            // console.log(self.forwardList);
            api.Deliver.saveMailDeliver(Object.assign({}, pm, { autoForward }), function (res) {
              // console.log(res)
              if(res.data.code === 0) {
                self.$message({
                  type: 'success',
                  message: self.$i18n.t('wm_lang_33130f')+'!'
                });
              }
            })
          })(xmail.api, xmail.enums, xmail.pms);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .setComponent{padding:10px;}
 .setComponent .title .el-divider--horizontal{margin:10px 0;}
  .forward-list{ width: 360px; height: 150px; display: inline-block; overflow: auto; border: solid #DCDFE6 1px; border-radius: 5px;margin-right:12px;}
  .forward-list li { line-height: 26px; padding: 2px 5px}
 .forward-list li:hover, .forward-list li.selected { background-color: #409EFF;color:#fff;}
 .mb0{margin-bottom:0px!important;}
 .mb10{margin-bottom:10px!important;}
 .w360{width:360px;}
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/forwardReply.vue